"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectCreationMetaResponseModelType = void 0;
exports.ProjectCreationMetaResponseModelType = {
    Blank: "blank",
    GeneratePodcast: "generate_podcast",
    AutoAssignVoices: "auto_assign_voices",
};
